module.exports = __webpack_public_path__ + "media/newstyle/images/icon-submarino-8c946fcd021a3831e8b5cf7fac368c88.svg";